import {VIEW_TYPE, FACE_TYPE, AXIS_TYPE} from '../constants/Type'
import * as SpaceUtil from './Space'
import * as CalcUtil from './Calc'

/** 面処理ユーティリティ */

/**
 * 画面表示用面種別から実際の空間の面への変換(2D->3D)
 * @param  {string} faceType 画面上の面種別
 * @param  {Object} viewType ビュー種別(VIEW_TYPE)
 * @param  {Number} viewRotation ビューの回転角
 * @return {string} 実際の面種別
 */
export const convertFaceTypeFromDisp = (faceType, viewType, viewRotation) => {
  let converted = faceType
  switch (viewType) {
    case VIEW_TYPE.FRONT:
      break
    case VIEW_TYPE.BACK:
      switch (faceType) {
        case FACE_TYPE.RIGHT: converted = FACE_TYPE.LEFT; break
        case FACE_TYPE.LEFT: converted = FACE_TYPE.RIGHT; break
        case FACE_TYPE.FRONT: converted = FACE_TYPE.BACK; break
        case FACE_TYPE.BACK: converted = FACE_TYPE.FRONT; break
      }
      break
    case VIEW_TYPE.TOP:
      switch (faceType) {
        case FACE_TYPE.TOP: converted = FACE_TYPE.BACK; break
        case FACE_TYPE.BOTTOM: converted = FACE_TYPE.FRONT; break
        case FACE_TYPE.FRONT: converted = FACE_TYPE.TOP; break
        case FACE_TYPE.BACK: converted = FACE_TYPE.BOTTOM; break
      }
      break
    case VIEW_TYPE.BOTTOM:
      switch (faceType) {
        case FACE_TYPE.TOP: converted = FACE_TYPE.FRONT; break
        case FACE_TYPE.BOTTOM: converted = FACE_TYPE.BACK; break
        case FACE_TYPE.FRONT: converted = FACE_TYPE.BOTTOM; break
        case FACE_TYPE.BACK: converted = FACE_TYPE.TOP; break
      }
      break
    case VIEW_TYPE.RIGHT:
      switch (faceType) {
        case FACE_TYPE.RIGHT: converted = FACE_TYPE.BACK; break
        case FACE_TYPE.LEFT: converted = FACE_TYPE.FRONT; break
        case FACE_TYPE.FRONT: converted = FACE_TYPE.RIGHT; break
        case FACE_TYPE.BACK: converted = FACE_TYPE.LEFT; break
      }
      break
    case VIEW_TYPE.LEFT:
      switch (faceType) {
        case FACE_TYPE.RIGHT: converted = FACE_TYPE.FRONT; break
        case FACE_TYPE.LEFT: converted = FACE_TYPE.BACK; break
        case FACE_TYPE.FRONT: converted = FACE_TYPE.LEFT; break
        case FACE_TYPE.BACK: converted = FACE_TYPE.RIGHT; break
      }
      break
    default:
  }
  return getFaceByViewRotation(converted, viewType, viewRotation)
}

/**
 * ビューの回転を考慮して、空間の対象面を取得する
 */
const getFaceByViewRotation = (faceType, viewType, viewRotation) => {
  let faceList = getAroundFaceList(viewType)
  if (!faceList.includes(faceType)) {
    return faceType
  }
  // viewRotationが正の場合：順方向、負の場合：逆方向
  let rotateStep = isNaN(viewRotation) ? 0 : (4 + Math.floor((viewRotation % 360) / 90)) % 4
  let idx = (faceList.indexOf(faceType) + rotateStep) % 4
  return faceList[idx]
}

/**
 * ビューの正面を返却する
 */
export const getFrontFace = (viewType) => {
  let faceType = FACE_TYPE.UNDEFINED
  switch (viewType) {
    case VIEW_TYPE.FRONT:
      faceType = FACE_TYPE.FRONT
      break
    case VIEW_TYPE.BACK:
      faceType = FACE_TYPE.BACK
      break
    case VIEW_TYPE.TOP:
      faceType = FACE_TYPE.TOP
      break
    case VIEW_TYPE.BOTTOM:
      faceType = FACE_TYPE.BOTTOM
      break
    case VIEW_TYPE.RIGHT:
      faceType = FACE_TYPE.RIGHT
      break
    case VIEW_TYPE.LEFT:
      faceType = FACE_TYPE.LEFT
      break
  }
  return faceType
}

/**
 * ビューに応じた周囲4辺の面リストを返却する
 */
const getAroundFaceList = (viewType) => {
  let faceList = []
  switch (viewType) {
    case VIEW_TYPE.FRONT:
    case VIEW_TYPE.BACK:
      faceList = [FACE_TYPE.LEFT, FACE_TYPE.BOTTOM, FACE_TYPE.RIGHT, FACE_TYPE.TOP]
      break
    case VIEW_TYPE.TOP:
    case VIEW_TYPE.BOTTOM:
      faceList = [FACE_TYPE.LEFT, FACE_TYPE.FRONT, FACE_TYPE.RIGHT, FACE_TYPE.BACK]
      break
    case VIEW_TYPE.RIGHT:
    case VIEW_TYPE.LEFT:
      faceList = [FACE_TYPE.FRONT, FACE_TYPE.BOTTOM, FACE_TYPE.BACK, FACE_TYPE.TOP]
      break
  }
  return viewType.isBase ? faceList : faceList.reverse()
}

/**
 * 空間の面種別から画面表示用面種別への変換(3D->2D)
 * @param  {string} faceType 空間上の面種別
 * @param  {Object} viewType ビュー種別(VIEW_TYPE)
 * @param  {Number} viewRotation ビューの回転角
 * @return {string} 実際の面種別
 */
export const convertFaceTypeForDisp = (faceType, viewType, viewRotation) => {
  if (!faceType || !viewType) {
    return faceType
  }
  // ビューの回転を反映
  let converted = getFaceByViewRotation(faceType, viewType, -viewRotation)
  switch (viewType) {
    case VIEW_TYPE.FRONT:
      break
    case VIEW_TYPE.BACK:
      switch (converted) {
        case FACE_TYPE.RIGHT: converted = FACE_TYPE.LEFT; break
        case FACE_TYPE.LEFT: converted = FACE_TYPE.RIGHT; break
        case FACE_TYPE.FRONT: converted = FACE_TYPE.BACK; break
        case FACE_TYPE.BACK: converted = FACE_TYPE.FRONT; break
      }
      break
    case VIEW_TYPE.TOP:
      switch (converted) {
        case FACE_TYPE.BACK: converted = FACE_TYPE.TOP; break
        case FACE_TYPE.FRONT: converted = FACE_TYPE.BOTTOM; break
        case FACE_TYPE.TOP: converted = FACE_TYPE.FRONT; break
        case FACE_TYPE.BOTTOM: converted = FACE_TYPE.BACK; break
      }
      break
    case VIEW_TYPE.BOTTOM:
      switch (converted) {
        case FACE_TYPE.FRONT: converted = FACE_TYPE.TOP; break
        case FACE_TYPE.BACK: converted = FACE_TYPE.BOTTOM; break
        case FACE_TYPE.BOTTOM: converted = FACE_TYPE.FRONT; break
        case FACE_TYPE.TOP: converted = FACE_TYPE.BACK; break
      }
      break
    case VIEW_TYPE.RIGHT:
      switch (converted) {
        case FACE_TYPE.BACK: converted = FACE_TYPE.RIGHT; break
        case FACE_TYPE.FRONT: converted = FACE_TYPE.LEFT; break
        case FACE_TYPE.RIGHT: converted = FACE_TYPE.FRONT; break
        case FACE_TYPE.LEFT: converted = FACE_TYPE.BACK; break
      }
      break
    case VIEW_TYPE.LEFT:
      switch (converted) {
        case FACE_TYPE.FRONT: converted = FACE_TYPE.RIGHT; break
        case FACE_TYPE.BACK: converted = FACE_TYPE.LEFT; break
        case FACE_TYPE.LEFT: converted = FACE_TYPE.FRONT; break
        case FACE_TYPE.RIGHT: converted = FACE_TYPE.BACK; break
      }
      break
    default:
  }
  return converted
}

/**
 * 基準面判定
 */
export const isBaseFace = (faceType) => {
  switch (faceType) {
    case FACE_TYPE.LEFT:
    case FACE_TYPE.BOTTOM:
    case FACE_TYPE.BACK:
      return true
    default:
  }
  return false
}

/**
 * 基準面取得
 */
export const getBaseFace = (axisType) => {
  switch (axisType) {
    case AXIS_TYPE.X: return FACE_TYPE.LEFT
    case AXIS_TYPE.Y: return FACE_TYPE.BOTTOM
    case AXIS_TYPE.Z: return FACE_TYPE.BACK
    default:
  }
  return FACE_TYPE.UNDEFINED
}

/**
 * 反対面取得
 */
export const getOtherFace = (faceType) => {
  switch (faceType) {
    case FACE_TYPE.LEFT: return FACE_TYPE.RIGHT
    case FACE_TYPE.RIGHT: return FACE_TYPE.LEFT
    case FACE_TYPE.BOTTOM: return FACE_TYPE.TOP
    case FACE_TYPE.TOP: return FACE_TYPE.BOTTOM
    case FACE_TYPE.BACK: return FACE_TYPE.FRONT
    case FACE_TYPE.FRONT: return FACE_TYPE.BACK
    default:
  }
  return FACE_TYPE.UNDEFINED
}

/**
 * 面の直交軸取得
 */
export const getVerticalAxis = (faceType) => {
  switch (faceType) {
    case FACE_TYPE.LEFT:
    case FACE_TYPE.RIGHT:
      return AXIS_TYPE.X
    case FACE_TYPE.BOTTOM:
    case FACE_TYPE.TOP:
      return AXIS_TYPE.Y
    case FACE_TYPE.BACK:
    case FACE_TYPE.FRONT:
      return AXIS_TYPE.Z
    default:
  }
  return AXIS_TYPE.UNDEFINED
}

/**
 * 面の直交軸判定
 */
export const isFaceOfAxis = (faceType, axisType) => {
  return axisType === getVerticalAxis(faceType)
}

/**
 * 面の線取得
 * @param  {Object} space 空間データ(グローバル座標、ビュー変換前)
 * @param  {Object} viewType ビュー種別(VIEW_TYPE)
 * @param  {Number} viewRotation ビューの回転角
 */
export const getFaceLine = (space, faceType, viewType, viewInverse, viewRotation) => {
  let converted = SpaceUtil.convertSpaceDataForDisp(space, viewType, viewRotation)
  let faceType2D = convertFaceTypeForDisp(faceType, viewType, viewRotation)
  if ((viewInverse.x && isFaceOfAxis(faceType2D, AXIS_TYPE.X)) || (viewInverse.y && isFaceOfAxis(faceType2D, AXIS_TYPE.Y))) {
    faceType2D = getOtherFace(faceType2D)
  }
  switch (faceType2D) {
    case FACE_TYPE.LEFT:
      return {x1: converted.x, y1: converted.y, x2: converted.x, y2: converted.y + converted.h}
    case FACE_TYPE.RIGHT:
      return {x1: converted.x + converted.w, y1: converted.y, x2: converted.x + converted.w, y2: converted.y + converted.h}
    case FACE_TYPE.BOTTOM:
      return {x1: converted.x, y1: converted.y, x2: converted.x + converted.w, y2: converted.y}
    case FACE_TYPE.TOP:
      return {x1: converted.x, y1: converted.y + converted.h, x2: converted.x + converted.w, y2: converted.y + converted.h}
    default:
      return {}
  }
}

/**
 * 面間距離取得
 * 平行面でない場合、null
 */
export const getFaceDistance = (space1, face1, space2, face2) => {
  if (getVerticalAxis(face1) !== getVerticalAxis(face2)) return null
  let pos1 = getFacePosition(space1, face1)
  let pos2 = getFacePosition(space2, face2)
  return (pos1 === null || pos2 === null) ? null : CalcUtil.round(pos2 - pos1)
}

/**
 * 面座標取得
 */
export const getFacePosition = (space, faceType) => {
  switch (faceType) {
    case FACE_TYPE.LEFT: return space.x
    case FACE_TYPE.RIGHT: return space.x + space.w
    case FACE_TYPE.BOTTOM: return space.y
    case FACE_TYPE.TOP: return space.y + space.h
    case FACE_TYPE.BACK: return space.z
    case FACE_TYPE.FRONT: return space.z + space.d
    case FACE_TYPE.LRC: return space.x + (space.w / 2)
    case FACE_TYPE.BTC: return space.y + (space.h / 2)
    case FACE_TYPE.BFC: return space.z + (space.d / 2)
  }
  return null
}



// WEBPACK FOOTER //
// ./src/main/js/utils/Face.js